import { CollectionFilter } from "@/modules/DashboardTemplate/models/CollectionFilter";
import {
  AxisXY,
  OptionsChart
} from "@/modules/DashboardTemplate/models/optionsChart";
import { PropertiesChart } from "@/modules/DashboardTemplate/models/PropertiesChart";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { Utils } from "@/shared/utils/utils";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { GRID_CHART, TITLE_CHART } from "../ChartsConstants";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { UserService } from "@/modules/User/services/UserService";
import {
  detectChartBarClick,
  getUserByDocument
} from "@/modules/DashboardTemplate/Utils";

@Component({
  name: "BarChart",
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      refreshCharts: "getRefreshCharts"
    })
  }
})
export default class BarChart extends Vue {
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  refreshCharts!: number;

  @Inject() userService!: UserService;

  @Prop() propertiesToChart!: PropertiesChart;
  @Prop() dataToGraph?: CollectionFilter;

  chartOptions: OptionsChart = new OptionsChart();

  showMenu = false;
  menuX = 0;
  menuY = 0;
  selectedBarData: any = null;

  mounted() {
    this.chart();

    this.$nextTick(() => {
      const chartRef = this.$refs.myChart as any;
      if (chartRef && chartRef.$el) {
        chartRef.$el.addEventListener("contextmenu", (e: MouseEvent) => {
          e.preventDefault();
          this.handleRightClick(e);
        });
      }
    });
  }

  @Watch("refreshCharts")
  @Watch("propertiesToChart", { deep: true })
  onChangeData() {
    this.chart();
  }

  chart() {
    if (!this.dataToGraph) return;
    const dataToGraph = this.dataToGraph;
    const chartData = dataToGraph.chartData;
    const yAxis: AxisXY[] = [{ type: "value" }];
    const xAxis: AxisXY[] = [
      {
        type: "category",
        data: dataToGraph.chartData.xAxis,
        axisLabel: {
          rotate: 45 // gira el texto 45 grados
        }
      }
    ];
    if (this.propertiesToChart.chartType.includes("horizontal")) {
      yAxis[0] = { type: "category", data: chartData.xAxis };
      xAxis[0] = {
        type: "value",
        axisLabel: {
          rotate: 45
        }
      };
    }

    const colors = Utils.generateColorsTones(
      this.propertiesToChart.chartColor.hex,
      6
    );
    this.chartOptions = {
      title: {
        ...TITLE_CHART,
        text: dataToGraph.chartName
      },
      tooltip: {},
      grid: {
        ...GRID_CHART
      },
      xAxis,
      yAxis,
      series: [
        {
          name: dataToGraph.collection[0].name,
          type: "bar",
          data: chartData.data[0].data,
          itemStyle: {
            color: (params: any) => {
              return colors[params.dataIndex % colors.length];
            }
          }
        }
      ]
    };
  }

  handleClick(event: any) {
    this.$emit("click", {
      chartType: "bar",
      event
    });
  }

  handleRightClick(e: MouseEvent) {
    const allowedGroupBy = ["document", "owner", "user", "userId"];
    const groupById = (this.propertiesToChart.groupBy[0] as DynamicSelectData)
      ?.id;

    if (!groupById || !allowedGroupBy.includes(groupById)) {
      return;
    }

    if (!this.dataToGraph) {
      return;
    }

    // Usar la función de utilidad para detectar el click
    const chartRef = this.$refs.myChart as any;
    const barData = detectChartBarClick(
      e,
      chartRef,
      this.dataToGraph.chartData.xAxis,
      this.dataToGraph.chartData.data[0].data,
      this.dataToGraph.collection[0].name
    );

    // Si se detectó un click válido en una barra
    if (barData) {
      this.selectedBarData = barData;

      // Ocultar el tooltip
      if (chartRef && chartRef.chart) {
        chartRef.chart.dispatchAction({ type: "hideTip" });
      }

      // Mostrar el menú contextual
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.showMenu = true;
    }
  }

  async onMenuAction() {
    // Buscar usuario usando la función de utils
    const userId = await getUserByDocument(
      this.selectedBarData.label,
      this.userService
    );

    // Si se encontró el usuario, abrir su perfil en nueva pestaña
    if (userId) {
      const route = this.$router.resolve({ path: `/profile/${userId}` });
      window.open(route.href, "_blank");
      this.showMenu = false;
      return;
    }

    const route = this.$router.resolve({
      path: `/profile/${this.selectedBarData.label}`
    });
    window.open(route.href, "_blank");
    this.showMenu = false;

    // Cerrar el menú contextual
  }
}
